import React from 'react';
import {Field} from 'redux-form/immutable';
import {CheckboxGroupField} from 'redux-form-antd'
import {
    required,
} from "../validDesc";
const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
    },
};

const SseS5 = props => {
    const ans = '生活習慣'
    const select_arr = [
        {
            value: '1',
            label: '整潔'
        },
        {
            value: '2',
            label: '勤勞'
        },
        {
            value: '3',
            label: '節儉'
        },
        {
            value: '4',
            label: '作息有規律'
        },
        {
            value: '5',
            label: '骯髒'
        },
        {
            value: '6',
            label: '懶惰'
        },
        {
            value: '7',
            label: '浪費'
        },
        {
            value: '8',
            label: '作息無規律'
        }
    ]
    return (
        <div>
            <Field {...formItemLayout} validate={required} component={CheckboxGroupField} options={select_arr} label={ans} name="sse_s5"
                   type="checkbox"/>
        </div>
    )
}

export default SseS5


// WEBPACK FOOTER //
// ./src/dashboards_redux/containers/TransferStudentContaioner/TransferStudentForm/SseS5.jsx